// extracted by mini-css-extract-plugin
module.exports = {"imagesSlider":"Slider_imagesSlider__ngsyN","noOffset":"Slider_noOffset__3aKbQ"};